import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import CategoriesApi from '../../../../services/api/CategoriesApi';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import styled from 'styled-components';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
});

export default function CategoryEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState(null);
  const history = useHistory();

  const getItem = async () => {
    const res = await CategoriesApi.get(id);
    setItemData(res.data);
  };
  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await CategoriesApi.update(id, values);
    if (res.status === StatusCodes.OK) {
      history.push('/categories');
    } else {
      setSubmitting(false);
    }
  };

  const onDelete = async () => {
    const res = await CategoriesApi.delete(id);
    if (res.status === StatusCodes.OK) {
      history.push('/categories');
    }
  };

  useEffect(() => {
    getItem(id);
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        title="Edit Category"
        onLeftHandler={() => {
          history.goBack();
        }}
      />
      {itemData !== null ? (
        <Formik
          initialValues={{
            name: itemData.name,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <FormWrapper>
              <form onSubmit={handleSubmit} autoComplete="off">
                <FormRow>
                  <TextInputComponent
                    name="name"
                    label="name"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    cols={12}
                  />
                </FormRow>
                <ActionWrapper>
                  <PrimaryButton variant="primary" isSubmitting={isSubmitting} type="submit" title="Save" />
                  <BorderlessButton
                    marginLeft="30px"
                    variant="danger"
                    size="sm"
                    type="submit"
                    onClick={onDelete}
                    title="Delete"
                  />
                </ActionWrapper>
              </form>
            </FormWrapper>
          )}
        </Formik>
      ) : null}
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
